import {Component, OnInit} from '@angular/core';
import {UserService} from './user-service';
import {UserDetailsComponent} from './user-details';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Observable, Subscriber} from 'rxjs';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {ModalContentComponent} from '../other/chf_popup';
import {ModalMessageComponent} from '../other/generic_popup';

declare var CANTORVERSION: any;
declare var DobryKantor: any;

@Component({
    selector: 'dk-user-page',
    template: require("./user-page.html"),
    providers: [ UserService ],
    entryComponents: [ UserDetailsComponent ]
})

export class UserPageComponent implements OnInit {
    showMenu: Observable<boolean>;
    showMenuObserver: Subscriber<boolean>;
    showMenuValue: boolean;

    showCurrencyRatesTable: Observable<boolean>;
    showCurrencyRatesTableObserver: Subscriber<boolean>;
    showCurrencyRatesTableValue: boolean;

    topUrl: string;

    closeResult = '';

    constructor(private userService: UserService, 
        private translate: TranslateService, 
        private router: Router, 
        private modalService: NgbModal) {

        this.showCurrencyRatesTable = new Observable(observer => {
            this.showCurrencyRatesTableObserver = observer;
        });

        this.showMenu = new Observable(observer => {
            this.showMenuObserver = observer;
        });

        this.showMenu.subscribe(next => {
            this.showMenuValue = next;

            if (next) {
                $('html').addClass('main-nav-container-visible');
            } else {
                $('html').removeClass('main-nav-container-visible');
            }
        });

        this.showCurrencyRatesTable.subscribe(next => {
            this.showCurrencyRatesTableValue = next;

            if (next) {
                $('html').addClass('main-nav-container-visible');
            } else {
                $('html').removeClass('main-nav-container-visible');
            }
        });

        let t1 = require('./../../root/backend/translations/translations.pl.json');
        let t2 = require('./../../root/backend/translations/translations.' + CANTORVERSION + '.pl.json');

        let t3 = this.mergeDeep({}, t1, t2);

        translate.setTranslation('pl', t3);
        translate.setDefaultLang('pl');
        translate.use('pl');

        let viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (viewportWidth < 1240) {
            this.showMenuObserver.next(false);
        }

        router.events.subscribe((val) => {
            if (viewportWidth < 1240) {
                this.showMenuObserver.next(false);
            }
        });

        this.topUrl = DobryKantor.params.cantor.topUrl;
    }

    isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }

    mergeDeep(target, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();

        if (this.isObject(target) && this.isObject(source)) {
            for (const key in source) {
                if (this.isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    this.mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }

        return this.mergeDeep(target, ...sources);
    }

    ngOnInit() {
        this.showCurrencyRatesTableObserver.next(false);
        this.showMenuObserver.next(true);
        this.userService.checkOffer().subscribe(result => {
            if (result===1) {
                this.openModalChf();
            } 
        });
        this.userService.getMessages().subscribe(result => {
            result.forEach(msg => {
                if(msg.Popup==1){
                    this.openModal(msg.id, msg.Temat, msg.Tresc);
                }
            });
        });

        // this.openModal(null, "title", "lorem ipsum")
    }

    public openModalChf(){

        const options: NgbModalOptions = {
            size: 'sm',
            centered: true,
            windowClass: 'chf-offer-modal'
          };

        this.modalService.open(ModalContentComponent, options);
    }

    public openModal(id: any, title: string, content: string){

        const options: NgbModalOptions = {
            size: 'lg',
            centered: true,
            windowClass: 'generic-modal'
          };

        const modalRef = this.modalService.open(ModalMessageComponent, options);
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.content = content;
        modalRef.componentInstance.id = id;
    }

    toggleMenu() {
        this.showMenuObserver.next(!this.showMenuValue);
        this.showCurrencyRatesTableObserver.next(false);
    }

    toggleCurrencyRatesTable() {
        this.showCurrencyRatesTableObserver.next(!this.showCurrencyRatesTableValue);
    }

    closeMenu = () => {
        this.showMenuObserver.next(false);
    }

    closeCurrencyRatesTable = () => {
        this.showCurrencyRatesTableObserver.next(false);
    }
}
